var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "a",
      {
        class: {
          "mobile-banner": true,
          "d-none": _vm.$router.currentRoute.meta.officeAdmin
        },
        attrs: { href: "http://onelink.to/wtr52f" }
      },
      [_vm._m(0), _vm._v(" "), _vm._m(1)]
    ),
    _vm._v(" "),
    _c("nav", [
      _c(
        "ul",
        {
          staticClass:
            "nav navbar justify-content-between align-items-center bg-white"
        },
        [
          _c(
            "li",
            { staticClass: "nav-item pull-sm-left" },
            [
              !_vm.adminMenuButtonHide
                ? _c(
                    "router-link",
                    { attrs: { to: "/restaurants", id: "logo" } },
                    [
                      _c("img", {
                        staticClass: "logo d-sm-block",
                        attrs: {
                          src: require("../assets/img/logo-uncatering.png"),
                          alt: "Uncatering",
                          "text-align": "center",
                          "data-retina": "true"
                        }
                      })
                    ]
                  )
                : _c("font-awesome-icon", {
                    staticClass: "nav--icon",
                    attrs: { icon: "bars", size: "2x" },
                    on: {
                      click: function($event) {
                        return _vm.showAdminMenu()
                      }
                    }
                  })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "text-white dropdown pull-sm-right navMenu" },
            [
              _c(
                "a",
                {
                  staticClass:
                    "pull-left dropdown-toggle font-weight-bold text-bleck ",
                  attrs: {
                    href: "javascript:void(0);",
                    id: "navbarDropdown",
                    role: "button",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }
                },
                [
                  _c("div", { staticClass: "navMenu--container" }, [
                    _c("span", { staticClass: "name text-capitalize" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            (_vm.employee.first_name
                              ? _vm.employee.first_name
                              : "") +
                              " " +
                              (_vm.employee.last_name
                                ? _vm.employee.last_name
                                : "")
                          ) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "office-name" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.currentOrganization &&
                              _vm.currentOrganization.attributes
                                .organization_name
                          ) +
                          "\n            "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    staticClass: "caret",
                    attrs: { icon: "caret-down", size: "1x" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dropdown-menu dropdown-menu-right",
                  attrs: { "aria-labelledby": "navbarDropdown" }
                },
                [
                  _vm.currentOrganization &&
                  !_vm.currentOrganization.attributes.soft_deleted &&
                  _vm.currentEmp &&
                  (_vm.currentEmp.role == "admin" || _vm.currentEmp.team_admin)
                    ? _c(
                        "div",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass:
                                "dropdown-item drop-down-item admin-padding",
                              attrs: { to: "/admin" }
                            },
                            [_vm._v("\n              Admin\n            ")]
                          ),
                          _vm._v(" "),
                          _c("hr")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.employee && _vm.filteredEmployees.length >= 1
                    ? _c(
                        "div",
                        { staticClass: "org-container" },
                        [
                          _vm._l(_vm.filteredEmployees, function(emp, index) {
                            return _c(
                              "button",
                              {
                                key: emp.id,
                                class: {
                                  "dropdown-item office-button": true,
                                  "office-button-pad": index > 0
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.setOrganization(emp)
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "text-left" }, [
                                  _vm._v(
                                    _vm._s(
                                      emp && emp.attributes.organization_name
                                    )
                                  )
                                ])
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("hr")
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentOrganization &&
                  !_vm.currentOrganization.attributes.soft_deleted
                    ? _c(
                        "router-link",
                        {
                          staticClass: "dropdown-item drop-down-item",
                          attrs: { to: "/restaurants" }
                        },
                        [_vm._v("\n            Restaurants\n          ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "dropdown-item drop-down-item",
                      attrs: { to: "/orders" }
                    },
                    [_vm._v("\n            Orders\n          ")]
                  ),
                  _vm._v(" "),
                  _vm.currentOrganization &&
                  !_vm.currentOrganization.attributes.soft_deleted
                    ? _c(
                        "router-link",
                        {
                          staticClass: "dropdown-item drop-down-item",
                          attrs: { to: "/profile" }
                        },
                        [_vm._v("\n            Profile\n          ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "dropdown-item drop-down-item",
                      attrs: { to: "/faq" }
                    },
                    [_vm._v("\n            FAQs\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-item drop-down-item refer-text",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.showReferralModal.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("\n            Refer & Earn $100\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-item drop-down-item",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.logOut.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("\n            Logout\n          ")]
                  )
                ],
                1
              )
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("span", { staticClass: "mobile-text" }, [
        _vm._v(
          "\n        For a better experience, get our new mobile app\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "download-button mx-2" }, [
      _c("span", [_vm._v("Download")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c9161038", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9161038","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoggedInHeader.vue
// module id = null
// module chunks = 